import { render, staticRenderFns } from "./complaintsList.vue?vue&type=template&id=0f1d1068"
import script from "./complaintsList.vue?vue&type=script&lang=js"
export * from "./complaintsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports